{
  "common": {
    "productNoun": {
      "form": "formulier",
      "survey": "enquête",
      "quiz": "quiz"
    },
    "productNounCapitalized": {
      "form": "Formulier",
      "survey": "Enquête",
      "quiz": "Quiz"
    },
    "urlField": {
      "settingsTitle": "URL-veldinstellingen definiëren",
      "description": "Kies welke URL-types toegestaan zijn voor dit veld.",
      "allowAllDomains": "Alle domeinen toestaan",
      "allowAllDomainsDescription": "Any valid URL is accepted.",
      "allowOnlyDomains": "Alleen deze domeinen toestaan",
      "allowOnlyDomainsDescription": "Everything else is rejected.",
      "blockDomains": "Deze domeinen blokkeren",
      "blockDomainsDescription": "Everything else is accepted.",
      "domainsAllowed": "Toegestane domeinen",
      "domainsBlocked": "Domeinen geblokkeerd",
      "domainPlaceholder": "e.g., example.com",
      "domainPlaceholderAdd": "Add another",
      "domainHint": "Type a domain and press Enter to add.",
      "invalidDomain": "Voer een geldig domein in zonder http://, https:// of een pad.",
      "domainRequired": "Voeg minstens één domein toe voor deze optie.",
      "singleUrlInfo": "Per veld wordt slechts één URL ondersteund. Om meerdere URL's vast te leggen, maakt u afzonderlijke velden aan."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "seconden",
    "other": "-- Andere --",
    "customFieldExistsError": "Custom Field met deze naam bestaat al",
    "requiredField": "Dit veld is vereist",
    "uniqueKeyNotUniqueError": "Deze Key is niet uniek",
    "save": "Opslaan",
    "saving": "Opslaan",
    "typeAnOption": "Typ een optie",
    "unsaved": "Niet opgeslagen",
    "noSubmissionsFound": "Geen inzendingen gevonden",
    "sortBy": "Sorteren op",
    "clearAll": "Alles wissen",
    "submitSurvey": "Enquête Indienen",
    "select": "Selecteren",
    "data": "gegevens",
    "enterAmount": "Voer aantal in",
    "disqualifyAfterSubmitLower": "Diskwalificeren na verzenden",
    "errorRetryAgain": "Fout, probeer het opnieuw",
    "savedSuccessfully": "Succesvol opgeslagen!",
    "couldntSaveChanges": "Kon wijzigingen niet opslaan. Probeer het opnieuw.",
    "emailNotificationSettingsUpdated": "Uw instellingen voor e-mailmeldingen zijn bijgewerkt.",
    "autoResponderSettingsUpdated": "Uw instellingen voor de automatische beantwoorder zijn bijgewerkt.",
    "bubbleRadioStyleImageAlt": "Bubble radio stijl",
    "standardRadioStyleImageAlt": "Standaard radio stijl",
    "recurringFrequency": {
      "once": "Eenmaal",
      "daily": "Dagelijks",
      "weekly": "Wekelijks",
      "monthly": "Maandelijks",
      "yearly": "Jaarlijks"
    },
    "saveExitConfirmationSubText": "Toon een bevestigingsvenster wanneer de gebruiker de pagina verlaat.",
    "yes": "Ja",
    "no": "Nee",
    "updated": "Bijgewerkt",
    "new": "Nieuw",
    "title": "Titel",
    "openSettings": "Instellingen openen",
    "cloneField": "Veld klonen",
    "removeField": "Veld verwijderen",
    "description": "Beschrijving",
    "cannotAddThisField": "U kunt dit veld niet toevoegen",
    "overallOnly": "Alleen algemeen",
    "nextSlideDefault": "Volgende dia (Standaard)",
    "nextQuestion": "Volgende Vraag",
    "searchAddress": "Adres zoeken",
    "recurringDonation": "Terugkerende donatie",
    "recurringDonationDay": "Terugkerende donatie 1 dag",
    "recurringDonationWeek": "Terugkerende donatie 1 keer per week",
    "recurringDonationMonth": "Terugkerende donatie 1 maand",
    "recurringDonationYear": "Terugkerende donatie voor 1 jaar",
    "integrate": "Integreren",
    "preview": "Voorbeeldweergave",
    "back": "Terug",
    "alert": "Melding",
    "proceed": "Doorgaan",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "delete": "Verwijderen",
    "embed": "Insluiten",
    "link": "Link",
    "linkModal": {
      "title": "Link invoegen",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.voorbeeld.nl",
      "invalidUrl": "Ongeldige URL"
    },
    "iframeEmbed": "Iframe insluiten",
    "styles": "Stijlen",
    "options": "Opties",
    "quickAdd": "Snel toevoegen",
    "customFields": "Aangepaste velden",
    "addObjectFields": "Object Velden Toevoegen",
    "personalInfo": "Persoonlijke gegevens",
    "contactInfo": "Contactgegevens",
    "submit": "Verzenden",
    "address": "Adres",
    "customized": "Aangepast",
    "layout": "Lay-out",
    "showLabel": "Toon label",
    "showImage": "Afbeelding tonen",
    "imageLayout": "Afbeelding uitlijnen van content",
    "imageLayoutSettings": "Lay-outinstellingen voor afbeeldingen",
    "imageLayoutMode": "Afbeelding Uitlijnen van content Modus",
    "surveyDefault": "Standaardinstelling voor enquête",
    "independent": "Onafhankelijk",
    "image": "Afbeelding",
    "desktop": "Computer",
    "mobile": "Mobiel",
    "desktopImage": "Computer afbeelding",
    "mobileImage": "Mobiel Afbeelding",
    "uploaded": "Geüpload",
    "changeImage": "Afbeelding wijzigen",
    "uploadImage": "Afbeelding uploaden",
    "remove": "Verwijderen",
    "background": "Achtergrond",
    "buttonBackground": "Background Button",
    "gradient": "Verloop",
    "type": "Type",
    "linear": "Lineair",
    "radial": "Radiaal",
    "angular": "Angular",
    "angle": "Hoek",
    "stops": "Stopt",
    "startColor": "Beginkleur",
    "endColor": "Eindkleur",
    "addColor": "Kleur toevoegen",
    "fontColour": "Kleur lettertype",
    "textFontColour": "Tekstkleur Lettertype",
    "subTextFontColour": "Subtekst Lettertypekleur",
    "selectThemes": "Theme Select",
    "selectOne": "Selecteer er een",
    "enableIcon": "Pictogram inschakelen",
    "iconType": "Type pictogram",
    "iconPlacement": "Pictogramplaatsing",
    "filled": "Ingevuld",
    "textOnly": "Alleen Body",
    "border": "Rand",
    "borderType": "Randtype",
    "cornerRadius": "Hoekstraal",
    "width": "Breedte",
    "padding": "Opvulling",
    "top": "Boven",
    "bottom": "Onder",
    "left": "Links",
    "right": "Rechts",
    "center": "Midden",
    "default": "Standaard",
    "formDefault": "Standaard Formulier",
    "shadow": "Schaduw",
    "color": "Kleur",
    "horizontal": "Horizontaal",
    "vertical": "Verticaal",
    "blur": "Onscherp",
    "spread": "Verspreiden",
    "fieldStyle": "Veldstijl",
    "fontColor": "Kleur lettertype",
    "inputTextFillColor": "Vulkleur invoertekst",
    "inputTextColor": "Kleur invoertekst",
    "primaryColor": "Hoofdkleur",
    "primaryColorTooltip": "Regelt de Kleur voor de hoverstatus en de Dynamisch Land.",
    "primaryColorTooltipLearnMore": "Meer informatie",
    "inputTextColorTooltip": "Regelt de Kleur van Tekst die in feedback Velden wordt getypt.",
    "mapPrimaryColorToButtonColor": "Mapping HOOFDZAKELIJK Kleur aan Knop Kleur",
    "label": "Label",
    "fontFamily": "Lettertypefamilie",
    "size": "Formaat",
    "weight": "Dikte",
    "fontWeightTooltip": "Van toepassing in het geval van paragrafen",
    "fontWeightOptions": {
      "thin": "100 - Dun",
      "extraLight": "200 - Extra licht",
      "light": "300 - licht",
      "normal": "400 - Normaal",
      "medium": "500 - Gemiddeld",
      "semiBold": "600 - Semi-Vet",
      "bold": "700 - Vet"
    },
    "placeholder": "Plaatshouder",
    "customCSS": "Aangepaste CSS",
    "backgroundImage": "Achtergrondafbeelding",
    "headerImage": "Kopafbeelding",
    "miscellaneous": "Diversen",
    "agencyBranding": "Branding van het agentschap",
    "imageUploadMessage": "Klik of sleep een afbeeldingsbestand naar dit gebied om te uploaden",
    "backgroundImageTooltipMessage": "De achtergrondafbeelding is bedoeld om de hele pagina te bedekken, om het formulier te voorzien van een visueel aantrekkelijke achtergrond. Klik op de optie Voorbeeld om de achtergrondafbeelding te bekijken.",
    "headerImageTooltipMessage": "De headerafbeelding is ontworpen om de volledige breedte van het formulier te bedekken en blijft bovenaan het formulier staan. Klik op de optie Voorbeeld om de headerafbeelding te bekijken.",
    "onSubmit": "Bij verzenden",
    "facebookPixelID": "Facebook Pixel-ID",
    "facebookPixelIDMessage": "Negeer dit veld als je dit formulier/deze enquête in een trechter wilt gebruiken",
    "facebookPixelEvents": "Gebeurtenissen Meta-pixel",
    "onpageView": "Op paginaweergave",
    "stickyContact": "Automatisch aangevuld contact",
    "stickyContactMessage": "Onthoudt en vult automatisch contactgegevens in wanneer u terugkeert op hetzelfde apparaat en in dezelfde browser.",
    "generateSubmissionDocument": "Genereer een indieningsdocument",
    "generateSubmissionDocumentMessage": "Maak automatisch een afdrukbaar PDF van elke inzending en voeg het toe aan de documenten van de contactpersoon",
    "saveQuizSubmissionAsPdf": "Quizinzending als pdf opslaan",
    "saveQuizResultAsPdf": "Uitslag van de quiz als pdf opslaan",
    "showSubmissionInConversationsFeed": "Gesprek aanmaken bij indiening",
    "showSubmissionInConversationsFeedMessage": "Er wordt automatisch een gespreksdraad aangemaakt wanneer dit formulier wordt ingediend, zodat u via e-mail, sms of andere kanalen kunt opvolgen vanuit het tabblad Gesprekken.",
    "fieldDescription": "Beschrijving veld",
    "fieldTitle": "Titel veld",
    "queryKey": "Query-ID",
    "querykeyTooltipMessage": "De querysleutel die als URL-parameter kan worden gebruikt om dit veld aan te vullen",
    "required": "Vereist",
    "hidden": "Verborgen",
    "hiddenValue": "Verborgen waarde",
    "enableCountryPicker": "Landkeuzelijst inschakelen",
    "altText": "Alternatieve tekst",
    "optionImageAlt": "Optie afbeelding",
    "bannerAlt": "banner",
    "avatarAlt": "Avatarnaam",
    "alignment": "Uitlijning",
    "imageWidth": "Breedte afbeelding",
    "imageHeight": "Afbeeldingshoogte",
    "logic": "Logica",
    "pleaseInput": "Invoeren",
    "editHTML": "HTML bewerken",
    "textStyle": "Tekstopmaak",
    "subText": "Subtekst",
    "text": "Tekst",
    "buttonStyle": "Knopstijl",
    "fullWidth": "Volledige breedte",
    "htmlMessage": "De aangepaste HTML komt hier te staan",
    "htmlEditorHeader": "AANGEPAST JAVASCRIPT / HTML",
    "htmlEditorBodyMessage": "Voeg hier je code toe",
    "scriptAdded": "Script Toegevoegd!",
    "sourceAddedForm": "Bron 'Formuliernaam'",
    "sourceAddedSurvey": "Bron 'Enquêtenaam'",
    "sourceAddedQuiz": "Bron \"Quiznaam\"",
    "yesSave": "Ja, opslaan",
    "cancelKeep": "Annuleren, Behouden",
    "done": "Voltooid",
    "addElement": "Element toevoegen",
    "addUrlLike": "Voeg geldige URL's toe zoals",
    "doNotAddRelativePath": "Voeg geen relatieve paden toe zoals",
    "or": "of",
    "addCustomFields": "Aangepaste velden toevoegen",
    "customFieldSearch": "Search by name",
    "selectedCount": "{count} geselecteerd",
    "noFieldsFound": "Geen velden gevonden",
    "noFieldsMatchQuery": "Er zijn geen velden die overeenkomen met '{query}'. Probeer een andere term of maak een nieuw veld aan.",
    "clearSearch": "Zoekopdracht wissen",
    "addFieldWithCount": "{count} veld toevoegen | {count} velden toevoegen",
    "noFieldsYet": "Nog geen velden",
    "noFieldsForObject": "Dit object heeft nog geen velden. Maak er een aan om te beginnen.",
    "createField": "Maak een veld aan",
    "enterSourceValue": "Voer bronwaarde in",
    "shortLabel": "Kort label",
    "shortLabelPlaceholder": "Short Label Type",
    "labelPlaceholder": "Type een label",
    "imagePlaceholder": "Afbeelding",
    "fillValuesPlaceholder": "Waarden toevoegen",
    "customCSSTooltip": "Aangepaste CSS heeft voorrang op formulieropmaak en thema's en kan een impact hebben op de vormgeving van het thema.",
    "fontFamilyTooltip": "Builder ondersteunt alle soorten lettertypes als je deze niet in de lijst kunt zien. Zoek in de vervolgkeuzelijst",
    "angleTooltip": "Bepaalt de richting van het verloop. 0° is naar rechts, 90° is naar beneden, 180° is naar links, 270° is naar boven.",
    "useGDPRCompliantFont": "Gebruik AVG-compatibel lettertype",
    "enableTimezone": "Tijdzone inschakelen",
    "inputStyle": "Invoerstijl",
    "conditionalLogicAlertOnSubmit": "Voorwaardelijke logica heeft hier voorrang op het bericht of de doorverwijzing",
    "conditionalLogicAlertOnShowHide": "Voorwaardelijke logica heeft hier voorrang op de verborgen instellingen",
    "placeholderFacebookPixelIdInput": "Voer de pixel-ID van Meta in",
    "doNotShowMessage": "Niet opnieuw tonen",
    "creatingForm": "Created je Form...",
    "creatingSurvey": "Heeft je Survey Created ...",
    "creatingQuiz": "Je quiz Created ...",
    "errorCreatingForm": "There is een fout Created je Form. Try again.",
    "errorCreatingSurvey": "There is een fout opgetreden Created je Survey. Try again.",
    "errorCreatingQuiz": "There is een fout Created . Try again.",
    "redirectMessage": "U wordt doorgestuurd naar:",
    "themes": {
      "themes": "Thema's",
      "alertThemeMessage": "Door het thema te wijzigen, gaan alle huidige vormgevingsaanpassingen verloren.",
      "useTheme": "Gebruik thema",
      "removeTheme": "Thema verwijderen"
    },
    "box": "Box",
    "line": "Lijn",
    "message": "Bericht",
    "openUrl": "Doorverwijzen naar URL",
    "borderTypeList": {
      "dotted": "Gestippeld",
      "dashed": "Onderbroken",
      "solid": "Ononderbroken",
      "none": "Geen"
    },
    "button": "Knop",
    "emailNotification": "E-mailmelding",
    "emailNotificationSubheader": "Ontvang een e-mail wanneer iemand je formulier invult",
    "subject": "Onderwerp",
    "emailTo": "E-mail (Aan)",
    "senderName": "Naam afzender",
    "senderNameWarning": "Je (subaccountnaam) wordt toegevoegd als dit leeg blijft",
    "emailError": "Er is minstens één e-mailadres vereist",
    "emailTooltip": "Voer een of meer e-mailadressen in die deze melding over het indienen van het formulier moeten ontvangen. Het eerste adres gaat in 'Aan'; extra adressen worden behandeld als 'CC'.",
    "emailTooltipForm": "Voer een of meer e-mailadressen in die deze melding over het indienen van het formulier moeten ontvangen. Het eerste adres gaat in 'Aan'; extra adressen worden behandeld als 'CC'.",
    "emailTooltipSurvey": "Voer een of meer e-mailadressen in die deze melding over het indienen van de enquête moeten ontvangen. Het eerste adres gaat in 'Aan'; extra adressen worden behandeld als 'CC'.",
    "emailTooltipQuiz": "Voer een of meer e-mailadressen in die deze melding over het indienen van de quiz moeten ontvangen. Het eerste adres gaat in 'Aan'; extra adressen worden behandeld als 'CC'.",
    "clear": "Wissen",
    "filter": "Filteren",
    "noResults": "Geen resultaten",
    "search": "Zoeken",
    "showNotificationsSettings": "Meldingsinstellingen tonen",
    "emailServicePaid": "Deze functie is een betaalde dienst met kosten op basis van je gebruik.",
    "integration": "Integratie",
    "validation": {
      "fieldRequired": "Field is Required",
      "maxLengthExceeded": "Max. Length overschreden ({max} Character)"
    },
    "securityValidation": {
      "title": "Beveiligingsproblemen gedetecteerd. De volgende zaken zijn niet toegestaan:",
      "cookieAccess": "Cookie-toegang gedetecteerd (document.cookie). Dit is om veiligheidsredenen niet toegestaan.",
      "storageAccess": "localStorage.getItem() - het lezen van localStorage is niet toegestaan.",
      "evalUsage": "Het gebruik van eval() is niet toegestaan omdat het willekeurige code kan uitvoeren.",
      "dynamicFunction": "Dynamische functiecreatie (new Function) is om veiligheidsredenen niet toegestaan.",
      "stringExecution": "Het doorgeven van strings aan setTimeout/setInterval is niet toegestaan omdat dit willekeurige code kan uitvoeren. Gebruik in plaats daarvan functiereferenties.",
      "unclosedTag": "Niet-afgesloten HTML-tag gedetecteerd (bijvoorbeeld een <style> zonder afsluitende </style>). Sluit alle tags voordat u opslaat, anders kan de gepubliceerde pagina mogelijk niet worden geladen."
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "{days} dagen gratis uitproberen",
      "setupFee": "Eenmalige configuratiekost",
      "quantity": "Aantal",
      "productImageAlt": "Productafbeelding",
      "bumpIconAlt": "Bump-pictogram"
    },
    "payment": {
      "payments": "Betalingen",
      "paymentProviders": "Betalingsaanbieders",
      "paymentProvidersDescription": "Verbind een betalingsprovider om betalingen te accepteren.",
      "connectedProviders": "Verbonden providers",
      "requireCreditCard": "Creditcard vereisen",
      "requireCreditCardTooltip": "Wanneer ingeschakeld, moeten klanten een creditcard invoeren, zelfs voor aankopen van $ 0.",
      "connectProviders": "Verbind aanbieders",
      "loading": "Aan het laden...",
      "generalTab": "Algemeen",
      "productTab": "Product",
      "connected": "Verbonden",
      "connect": "Verbinden",
      "liveModeOn": "Live weergave",
      "status": "Status",
      "test": "Test",
      "live": "Live",
      "paymentFields": "Betalingsvelden",
      "suggestAnAmount": "Stel een bedrag voor",
      "recurringPayments": "Terugkerende Betalingen",
      "selectCurrency": "Valuta selecteren",
      "tagActiveBGColor": "Actieve tagkleur",
      "includeOtherAmount": "Voeg een ander bedrag toe",
      "footerInfo": "Info voettekst",
      "paymentType": "Betalingstype",
      "sellProducts": "Producten verkopen",
      "customAmount": "Aangepast bedrag",
      "collectPayment": "Betaling innen",
      "generalSettings": "Algemene velden",
      "securePayments": "*100% Verkopen & veilig betalen*",
      "error": {
        "addMainProductFirst": "Add eerst een PRIMARY Product toe",
        "priceNotFoundForBumpProduct": "Price niet found voor Bump Product",
        "productAlreadyAdded": "Product al toegevoegd"
      },
      "product": {
        "addProduct": "Product toevoegen",
        "productSettings": "Productinstellingen",
        "bumpTag": "Bump",
        "settingsAria": "Productinstellingen",
        "deleteAria": "Product verwijderen",
        "selectProduct": "Selecteer product",
        "editThisProduct": "Dit product bewerken",
        "clickHere": "Klik hier",
        "show": "Tonen",
        "description": "Beschrijving",
        "image": "Afbeelding",
        "layoutSettings": "Lay-outinstellingen",
        "singleColumn": "Enkele kolom",
        "twoColumn": "Twee kolommen",
        "threeColumn": "Drie kolommen",
        "maxProductError": "Maximaal 20 producten toegestaan in een formulier",
        "productSelectPlaceholder": "Selecteer een product",
        "orderConfirmation": "Bestelbevestiging",
        "orderConfirmationWarning": "Zodra de betaling is geslaagd, wordt een pagina met de bestelbevestiging getoond",
        "quantity": "Aantal",
        "createProduct": "Om een product te maken",
        "noProductsAdded": "Nog geen producten toegevoegd",
        "productsWillShowHere": "Zodra You producten Add , worden ze Right here Show",
        "chooseProductType": "Product Select Type",
        "mainProduct": "PRIMARY Product",
        "primaryOffer": "Primair aanbod",
        "checkoutAddOn": "Add-on voor de kassa",
        "pricingOptions": "Prijsopties",
        "pricingOptionsPlaceholder": "Selecteer prijsopties (standaard: alle)",
        "all": "ALLE",
        "addOrSelectProducts": "Voeg producten toe of selecteer ze",
        "onceYouAddProductsTheyWillShowUpRightHere": "Zodra u producten toevoegt, worden ze hier weergegeven",
        "addProducts": "Producten toevoegen"
      },
      "bumProduct": {
        "price": "Prijs",
        "variant": "Variant",
        "headline": "Koptekst",
        "otoHeadline": "OTO Headline",
        "otoText": "OTO Body",
        "enableImage": "Image Enable",
        "imageMessage": "We nemen de Default Product",
        "orUploadADifferentImage": "Of een andere Image Upload",
        "bumpProducts": "Aanvullende producten",
        "bumpProduct": "Bump Product",
        "enableBump": "Bump Enable",
        "orderBumpStyle": "Order Bump Appearance",
        "classic": "Klassiek",
        "modern": "Modern",
        "icon": "Icon",
        "bumpTemplate": "Template . Select",
        "highlightText": "Body Highlight",
        "showPrice": "Show Price",
        "bumpPriceColor": "Aanvullende Price",
        "bumpIconColor": "Bump Icon",
        "bumpBackgroundColor": "Achtergrond stoten",
        "highlightTextColor": "Body Highlight",
        "headlineColor": "Koptekst",
        "otoHeadlineColor": "OTO Headline",
        "otoTextColor": "OTO Body",
        "bumpBorderColor": "Bump Border",
        "priceRequired": "Price is Required",
        "headlineRequired": "Headline is Required",
        "otoHeadlineRequired": "OTO-koptekst is vereist",
        "otoTextRequired": "OTO-tekst is vereist",
        "bumpProductTooltip": "Tijdens de Checkout wordt een Small Add-on aangeboden op Multiply Sort Value. Customers kunnen Add met Individual click.",
        "templateOne": "Sjabloon 1",
        "templateTwo": "Sjabloon 2",
        "templateThree": "Sjabloon 3",
        "animationIcon": {
          "none": "Geen",
          "arrow": "Pijltje",
          "fire": "Brand",
          "plus": "Plus",
          "giftBox": "Box",
          "timer": "Countdown",
          "cracker": "Cracker",
          "snack": "Tussendoortje",
          "partyBalloon": "Feestballon",
          "flash": "Flash",
          "money": "Currency",
          "spaceShuttle": "Room Shuttle"
        }
      },
      "coupons": {
        "coupons": "Coupons",
        "enableCoupon": "Coupon inschakelen",
        "couponAlignment": "Uitlijning coupons",
        "left": "Links",
        "right": "Rechts",
        "fullWidth": "Volledige breedte",
        "tooltipMessage": "Stel de positie van de couponinvoer in met de onderstaande types"
      }
    },
    "addressSettings": {
      "autoComplete": "Adres automatisch aanvullen",
      "addressfields": "Adresvelden",
      "placeholderSearch": "Zoek op adres",
      "autoCompleteTooltip": "Biedt de mogelijkheid om op adressen te zoeken en deze automatisch aan te vullen.",
      "streetAddress": "Straat Address",
      "autoCompleteAddressTitle": "Finish Auto Address",
      "newBadge": "new",
      "defaultLabel": "Adres",
      "searchPlaceholder": "Search Address",
      "mandataorySearch": {
        "title": "Required to Select Address in Bar",
        "primaryText": "Alleen automatisch aanvullen voor Address",
        "secondaryText": "When When Operator het Address Field Enabled , moet Then een geldig Address to Continue Select .",
        "secondaryText1": "When kunnen ze Continue zonder een Address Disabled selecteren in de Search ."
      }
    },
    "autoResponder": "Automatische beantwoorder",
    "workflow": "Workflow",
    "workflowSubheader": "Automatiseer wat er gebeurt nadat een formulier is ingediend",
    "workflowTitle": "Creëer uw eigen eenvoudige workflow.",
    "workflowDescription": "Gebruik workflows om de vervolgacties af te handelen nadat contactpersonen uw formulier hebben ingevuld. Bijvoorbeeld door ze een vervolgmail of sms te sturen.",
    "createWorkflow": "Workflow maken",
    "workflowVisualAlt": "Weergave van workflow",
    "autoResponderSubheader": "Verzend een automatische e-mail naar de persoon die het formulier heeft ingediend (de e-mail bevat een kopie van de informatie die op het formulier werd ingevuld)",
    "replyToEmail": "Antwoord op e-mail",
    "open": "Open",
    "won": "Gewonnen",
    "lost": "Verloren",
    "abandon": "Verlaten",
    "selectAPipeline": "Selecteer een pijplijn",
    "stage": "Stadium",
    "status": "Status",
    "opportunityValue": "Waarde opportuniteit",
    "createNewPipeline": "Maak een pijplijn aan",
    "editOpportunitySettings": "Instellingen opportuniteit bewerken",
    "contact": "Contactpersoon",
    "opportunity": "Opportuniteit",
    "business": "Bedrijf",
    "add": "Toevoegen",
    "manage": "Beheren",
    "more": "Meer",
    "opportunityHeading": "Waar wilt u uw opportuniteit bijwerken?",
    "date": {
      "dateSettings": "Datuminstellingen",
      "dateFormat": "Datumformaat",
      "dateSeparator": "Scheidingsteken datum",
      "dateFormatTooltipMessage": "Selecteer een datumnotatie. D staat voor dag, M voor maand en J voor jaar",
      "dateSeparatorTooltipMessage": "Selecteer een scheidingsteken dat de dag, maand en het jaar scheidt in de indeling die je hebt geselecteerd voor Datumnotatie",
      "disablePicker": "Picker uitschakelen"
    },
    "dateTime": {
      "tabGeneral": "Algemeen",
      "tabFieldSettings": "Veldinstellingen",
      "collectHeading": "Selecteer wat dit veld moet verzamelen",
      "collectDate": "Datum",
      "collectTime": "Tijd",
      "collectDateTime": "Datum en tijd",
      "collectTypeLockedTooltip": "Het verzameltype kan alleen worden gewijzigd voordat het veld wordt opgeslagen.",
      "placeholderTextPlaceholder": "Voeg plaatshoudertekst toe",
      "shortLabelPlaceholder": "Voeg een kort label toe",
      "fieldSettingsBanner": "Definieer het toegestane datum- of tijdsbereik, beperk welke dagen gebruikers kunnen kiezen, en bepaal hoe de waarde wordt weergegeven.",
      "allowedDateRange": "Toegestane datumbereik",
      "dateModeAny": "Elke datum",
      "dateModeFuture": "Alleen toekomstige data",
      "dateModePast": "Alleen datums uit het verleden",
      "dateModeRange": "Specifiek datumbereik",
      "futureQuestion": "Welke datums kunnen gebruikers kiezen?",
      "futureAny": "Elke toekomstige datum",
      "futureAnyDesc": "Gebruikers kunnen elke datum na de huidige datum kiezen. Bijvoorbeeld: boek op elk moment volgend jaar een vergadering.",
      "futureBuffer": "Na buffertijd",
      "futureBufferDesc": "Gebruikers kunnen alleen datums kiezen na een vastgesteld aantal dagen. Bijvoorbeeld: sta boekingen toe vanaf 3 dagen na vandaag.",
      "futureBufferSuffix": "dagen vanaf vandaag",
      "futureRolling": "Binnen een vastgesteld datumbereik",
      "futureRollingDesc": "Gebruikers kunnen datums kiezen binnen een gedefinieerd toekomstig bereik. Bijvoorbeeld: sta boekingen toe binnen de komende 30 dagen.",
      "futureRollingPrefix": "Volgende",
      "futureRollingSuffix": "dagen",
      "rangeLabel": "Specifiek datumbereik",
      "rangeStart": "Begindatum",
      "rangeEnd": "Einddatum",
      "availableDays": "Beschikbare dagen",
      "allowedTimeRange": "Toegestane tijdsperiode",
      "timeModeAny": "Op elk moment",
      "timeModeRange": "Specifieke tijdsperiode",
      "timeRangeLabel": "Specifieke tijdsperiode",
      "timeStart": "Begintijd",
      "timeEnd": "Eindtijd",
      "timeFormatLabel": "Tijdformaat",
      "timeFormat24": "24 uur",
      "timeFormat12": "AM / PM",
      "timePlaceholder": "UU:MM",
      "defaultTimeLabel": "Standaardtijd",
      "defaultTimeHelper": "Vul vooraf in met een huidige of aangepaste tijd.",
      "defaultTimeNone": "Geen",
      "defaultTimeCurrent": "Huidige",
      "defaultTimeCustom": "Aangepast",
      "customTimeLabel": "Aangepaste tijd",
      "customTimeError": "Voer een geldige tijd in in het HH:MM-formaat.",
      "disableCalendarPopup": "Schakel de kalender-pop-up uit",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Selecteer minstens één beschikbare dag",
      "dateRangeError": "Einddatum moet op of na de begindatum liggen",
      "timeRangeError": "De eindtijd moet na de begintijd liggen",
      "saveBlockedTitle": "Het datum- en tijdveld is onvolledig.",
      "saveBlockedDescription": "Corrigeer de gemarkeerde validatiefouten voor datum en tijd voordat u opslaat.",
      "weekday": {
        "mon": "Maand",
        "tue": "di",
        "wed": "wo",
        "thu": "do",
        "fri": "vr",
        "sat": "Zat",
        "sun": "Zon"
      }
    },
    "restoreVersion": "Herstel versie",
    "versionHistory": "Versiegeschiedenis",
    "errorMessage": "Fout, probeer het opnieuw",
    "version": "Versie:",
    "currentVersion": "Huidige versie",
    "messageStyling": "Berichtopmaak",
    "validateEmailHeader": "E-mail valideren",
    "validateEmailDescription": "De knop wordt getoond zodra de gebruiker een e-mailadres invoert. Deze functie is ontworpen om kwalitatieve leads te genereren.",
    "verifyEmail": "E-mail verifiëren",
    "validatePhoneHeader": "Telefoonnummer valideren",
    "validatePhoneDescription": "De knop wordt getoond zodra de gebruiker een telefoonnummer invoert. Deze functie is ontworpen om kwalitatieve leads te genereren.",
    "verifyPhone": "Telefoon verifiëren",
    "validatePhoneWarning": "Om SMS OTP-verificatie in te schakelen, moet je telefoonnummer zijn ingesteld in je locatie-instellingen",
    "addAnotherTnc": "Voeg nog een Algemene Voorwaarde toe",
    "tnc1": "Alg. Voorw. 1",
    "tnc2": "T & C 2",
    "deleteCaps": "VERWIJDEREN",
    "deleteConfirmation": "Typ VERWIJDEREN om te bevestigen",
    "marginPadding": "Marge en padding",
    "style": {
      "formLayoutType": "Formuliertype",
      "layoutType": "Lay-outtype",
      "surveyType": "Enquêtetype",
      "oneColumn": "Eén kolom",
      "twoColumn": "Twee kolommen",
      "singleLine": "Enkele lijn",
      "fieldWidth": "Breedte veld",
      "labelAlignment": {
        "labelAlignment": "Uitlijning label",
        "labelWidth": "Breedte label"
      },
      "fieldSpacing": "Afstand tussen velden",
      "imageFieldSpacing": "Afbeelding en veldafstand",
      "imageCornerRadius": "Afbeelding hoekstraal",
      "color": "kleur",
      "fontColor": "Kleur lettertype",
      "inputBackgroundColor": "Achtergrondkleur invoer",
      "inputBorder": "Invoerrand",
      "layout": "Layout",
      "colorsAndBackground": "Kleuren en achtergrond",
      "imageLayout": {
        "imageLayout": "Afbeelding uitlijnen van content",
        "showImage": "Afbeelding tonen",
        "image": "Afbeelding",
        "desktop": {
          "topFixed": "Bovenste Vast",
          "leftCenter": "Links gecentreerd",
          "rightCenter": "Rechts Midden",
          "leftFixed": "Links vastgezet",
          "rightFixed": "Rechts Vast",
          "background": "Achtergrond"
        },
        "mobile": {
          "header": "Header",
          "background": "Achtergrond"
        }
      },
      "focusPoint": {
        "title": "Focuspunt",
        "reset": "Herstellen",
        "noImage": "Er is geen afbeelding geüpload"
      },
      "advanceSettings": "Geavanceerde Settings",
      "inputField": "Invoerveld",
      "borderWidth": "Randbreedte",
      "borderColor": "Randkleur",
      "borderStyle": "Randstijl",
      "fontSize": "Lettergrootte",
      "fontWeight": "Lettergewicht",
      "labelColor": "Labelkleur",
      "placeholderColor": "Kleur placeholder",
      "shortLabelColor": "Korte labelkleur"
    },
    "replyToTooltip": "Specificeer het e-mailadres waar de antwoorden op deze melding naartoe moeten worden gestuurd. Gebruik {'{'}{'{'}contact.email{'}'}{'}'} om ontvangers direct te laten reageren op de persoon die het formulier heeft ingevuld.",
    "content": "Content",
    "calculations": "Berekeningen",
    "uploadOptions": "Uploadopties",
    "opportunitySettingsWarning": "Stel de opportuniteitsinstellingen in door op de knop Opportuniteitsinstellingen bewerken te klikken.",
    "startValue": "Beginnen Waarde",
    "endValue": "Eindwaarde",
    "today": "Vandaag",
    "thisWeek": "Deze week",
    "last7Days": "Laatste 7 dagen",
    "thisMonth": "Deze maand",
    "last30Days": "Laatste 30 dagen",
    "question": "Vraag",
    "createContactOnPartialSubmission": "Contact aanmaken bij gedeeltelijke indiening",
    "howItWorks": "Hoe werkt het?",
    "createContactOnPartialSubmissionDescription": "Rond de slide af en klik op 'Volgende'. Er wordt automatisch een nieuw contact aangemaakt en opgeslagen.",
    "swapWarningMessageSurvey": "Het bewerken of verwisselen van opties heeft invloed op dit aangepaste veld op alle plaatsen waar het wordt gebruikt. Het kan ook de voorwaardelijke logica resetten. ",
    "swapWarningMessageForm": "Het bewerken of verwisselen van opties heeft invloed op dit aangepaste veld op alle plaatsen waar het wordt gebruikt. ",
    "migrationWarningMessage": "Deze functionaliteit is gemigreerd naar de Voorwaardelijke Logica van de enquête.",
    "optionLabel": "Optielabel",
    "calculationValue": "Waarde berekening",
    "addOption": "Optie toevoegen",
    "enableCalculations": "Berekeningen inschakelen",
    "allowOtherOption": "Sta andere optie toe",
    "productSelectionSubtext": "Of Individual Product selecteren",
    "multi": "Multi",
    "single": "Individual",
    "productSelectionHeading": "Product",
    "spreadToColumns": "Verspreiden naar kolommen",
    "columns": "Kolommen",
    "customstyle": "Stijl",
    "standard": "Standaard",
    "bubble": "Bubble",
    "integratePopup": {
      "title": "Formulier integreren",
      "embedCode": "Insluitcode",
      "useInFunnelOrEmbedCode": "Gebruik in trechter/ insluitcode",
      "iframeEmbed": "Iframe Embed",
      "layout": {
        "title": "Ingesloten lay-outtype",
        "description": "Selecteer een lay-out om in te sluiten in een trechter of een externe website",
        "allowMinimize": "Minimaliseren toestaan",
        "minimizedTitlePlaceholder": "Geminimaliseerde titel",
        "leftAlignAlt": "Links uitlijnen",
        "rightAlignAlt": "Rechts uitlijnen"
      },
      "triggerType": "Triggertype",
      "triggers": {
        "seconds": "seconden"
      },
      "activation": {
        "title": "Activatieopties",
        "visit": "bezoek"
      },
      "deactivation": {
        "title": "Deactivatieopties",
        "times": "keer"
      },
      "copyEmbedCode": "Insluitcode kopiëren",
      "copyFormLink": "Link naar formulier kopiëren",
      "openFormLink": "Link naar formulier openen",
      "invalidInput": "Ongeldige invoer!",
      "funnel": {
        "funnel": "Trechter",
        "chooseStep": "Select a Step",
        "copyCodeAndOpenFunnel": "Copy Code & Open Funnel"
      },
      "share": {
        "share": "Delen",
        "shareViaSocials": "Share Via Socials",
        "copyLink": "Link kopiëren"
      },
      "email": {
        "email": "E-mail",
        "shareViaEmail": "Via Email Share",
        "emailButton": "E-mail",
        "blankTemplate": "Template Template",
        "emailMarketingTemplates": "Sjablonen voor Email Marketing",
        "or": "Of",
        "chooseTemplate": "Kies uit uw sjablonen",
        "continue": "Doorgaan"
      }
    },
    "rating": {
      "icon": "Icon",
      "iconAlignment": "Icon Alignment",
      "count": "Count",
      "lowestRating": "Min beoordeling",
      "highestRating": "Max. beoordeling",
      "iconSelectedState": "Icon Selected State",
      "iconUnselectedState": "Icon Niet geselecteerde State",
      "rating": "Beoordeling",
      "ratingSettings": "Rating Settings",
      "calculationType": {
        "calculationType": "Archive voor Rating Fields in Custom Fields",
        "calculationTypeTooltip": "When You Frequency iets 4 From 5 sterren, betekent dit: - Absoluut: 4 From 5 - Percentage: 80 - Fractie: 0,8",
        "absolute": "Absoluut",
        "percentage": "Percentage",
        "fraction": "Fractie"
      }
    },
    "desktopMode": "Weergave desktop",
    "mobileMode": "Weergave mobiel",
    "versions": "Variants",
    "advanced": "Geavanceerd",
    "edit": "Bewerken",
    "settings": "Instellingen",
    "submissions": "Inzendingen",
    "analytics": "Analyses",
    "notifications": "Meldingen",
    "undo": "Ongedaan maken",
    "redo": "Opnieuw",
    "customValues": "Aangepaste waarden",
    "pickBgFromImage": "Voegt een onscherpte toe aan de achtergrond van uw berichtvenster. Als u een achtergrondkleur voor het berichtvenster selecteert, wordt deze weergegeven over het vervaagde berichtvenster.",
    "pickBgFromImageTip": "Kies een Kleur met hoog Vergelijken voor de BG-Afbeelding. Bericht: Wordt niet toegepast als de Achtergrond van het Formulier geen Afbeelding heeft",
    "messageBackgroundBlur": "Achtergrond vervagen",
    "confirmationMessage": "Bevestigingsbericht",
    "deleteOption": "Removing Option",
    "deleteConfirmationModal": {
      "defaultDescription": "Het verwijderen van een optie heeft invloed op dit Aan Field voor every Seats waar het Field wordt gebruikt. Weet You zeker dat You het wilt Removing ?",
      "validationMessage": "Voer in Removing to Saving.",
      "validationError": "Voer in Removing"
    },
    "disqualifyImmediately": "Onmiddellijk diskwalificeren",
    "disqualifyAfterSubmit": "Diskwalificeren na indiening",
    "generalSettings": "General Settings",
    "advancedSettings": "Geavanceerde Settings",
    "customFieldName": "Custom Industry Name",
    "customFieldNameTooltip": "Deze Industry is uniek per Custom Industry.",
    "customFieldNameTooltipContact": "Deze velden stellen gebruikers in staat om extra details over een persoon vast te leggen, zoals het type lead, de geboortedatum of de gewenste contactmethode.",
    "customFieldNameTooltipContactLearnMore": "Meer informatie",
    "customFieldNameTooltipOpportunity": "Deze velden worden gebruikt om dealspecifieke gegevens bij te houden voor elke lead, waaronder informatie zoals het budget of een sluitingsdoel.",
    "customFieldNameTooltipOpportunityLearnMore": "Meer informatie",
    "customFieldNameTooltipCompany": "Deze velden stellen u in staat om informatie op organisatieniveau vast te leggen (bijv. voor verkopers, klanten of agentschappen) die gekoppeld is aan contactpersonen.",
    "customFieldNameTooltipCompanyLearnMore": "Meer informatie",
    "customFieldNameTooltipCustomObject": "Deze velden stellen gebruikers in staat bedrijfsspecifieke gegevens te verzamelen, zoals details over activa, voertuigen of eigenschappen, en deze informatie te integreren in hun CRM-systeem.",
    "customFieldNameTooltipCustomObjectLearnMore": "Meer informatie",
    "uniqueKey": "Unieke sleutel",
    "uniqueKeyTooltip": "Deze sleutel is de systeem-identificator voor het aangepaste veld. Eenmaal ingesteld, kan deze niet meer worden gewijzigd.",
    "uniqueKeyTooltipLearnMore": "Meer informatie",
    "selectContactAssociation": "Klik op de relatie met Contacten",
    "associations": "Associaties",
    "createNewAssociation": "Nieuwe associatie maken",
    "selectAnAssociation": "Selecteer een associatie",
    "loadingAssociations": "Associaties aan het laden...",
    "unknownAssociation": "Onbekende Relatie",
    "manyToMany": "Veel-op-veel",
    "failedToLoadAssociations": "Het laden van associaties is mislukt.",
    "noAssociationsFound": "Geen associaties gevonden",
    "keepThisField": "Houden dit Sector",
    "association": "Associatie",
    "customObject": "Aangepast object",
    "customObjects": "Aangepaste objecten",
    "object": "Object",
    "editAssociation": "{objectName} -associatie bewerken",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Velden",
    "primaryFieldWarning": "{fieldName} is een HOOFDZAKELIJK Sector voor {objectSingular} en is Vereist om een {objectSingular} Gemaakt of te Vernieuwen.",
    "primaryFieldTitle": "{fieldName} is Vereist om een {objectSingular} -Document te maken of te Vernieuwen.",
    "removeAllFields": "Verwijder alle {objectSingular} velden.",
    "customObjectsFallback": "Aangepaste objecten",
    "noneAssociation": "Geen",
    "noneAssociationDescription": "Geen relatie met Contactpersonen (geen Contactpersoon Velden aanwezig)",
    "survey": {
      "layoutType": "Enquêtetype",
      "oneQuestionPerPage": "Eén vraag tegelijk",
      "allQuestionsOnePage": "Veel tegelijk"
    },
    "quizQuestions": "Quiz Question",
    "choiceElements": "Choice Components",
    "otherElements": "Other Components",
    "listEditor": {
      "prefillValueHeader": "Prefill Value",
      "labelPlaceholder": "Label",
      "valuePlaceholder": "Waarde",
      "optionRequiredError": "De optie Field is Required"
    },
    "field": "Veld",
    "scoreEditor": {
      "addFieldPlaceholder": "Add Field",
      "fieldLabel": "Veld",
      "numberLabel": "number"
    },
    "fileUploadEditor": {
      "fileTypes": "File",
      "all": "every",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPG",
      "xlsCsv": "XLS/CSV"
    },
    "ok": "Oké",
    "allowMultipleFiles": "Meerdere Files Enable",
    "maxFileLimit": "Max File",
    "privacyPolicy": "Privacybeleid",
    "termsOfService": "of",
    "colorPicker": {
      "brandColors": "Merkkleuren",
      "defaultColors": "Standaardkleuren",
      "globalCustomColors": "Globale aangepaste kleuren"
    },
    "billingFrequency": "Factureringsfrequentie",
    "otherAmount": "Ander bedrag",
    "exampleUrlPlaceholder": "https://www.voorbeeld.nl",
    "checkboxStyles": {
      "standardAlt": "Standaard selectievakje stijl",
      "bubbleAlt": "Bubble selectievakje stijl"
    },
    "previewIcons": {
      "exportAlt": "Exportpictogram",
      "shipmentAlt": "Verzendpictogram",
      "resultAlt": "Pictogram van de resultatenpagina"
    },
    "examples": {
      "sampleUrl": "https://voorbeeld.nl"
    },
    "showing": "Weergeven",
    "of": "van",
    "enterCouponCode": "Voer kortingscode in",
    "apply": "Aanmelden",
    "paymentWillBeProcessed": "De betaling wordt verwerkt zodra u naar de volgende stap gaat",
    "paymentWillBeProcessedNextSlide": "De betaling wordt verwerkt zodra de gebruiker doorgaat naar de volgende dia",
    "showThisAlertToUsers": "Toon deze waarschuwing aan gebruikers",
    "sixteenDigitCardNumber": "16-cijferig kaartnummer",
    "mmYy": "MM / JJ",
    "cvc": "CVC",
    "threeDigitCode": "3-cijferige code",
    "enterCardNumber": "Voer kaartnummer in",
    "pleaseFillRequiredFields": "Vul alle vereiste velden in!",
    "opportunitySettingsIncomplete": "Instellingen verkoopgelegenheden onvolledig",
    "opportunitySettingsIncompleteDescription": "Dit formulier bevat verkoop-velden, maar de Instellingen verkoopgelegenheden zijn nog niet bijgewerkt. Stel de Instellingen verkoopgelegenheden in om verder te gaan met het opslaan van het formulier.",
    "ariaAttributes": {
      "iconSearch": "Pictogram zoeken"
    },
    "alt": {
      "standardRadioStyle": "Standaard radiostijl",
      "bubbleRadioStyle": "Bubble radiostijl"
    },
    "value": "Waarde",
    "jumpTo": "Ga naar",
    "thankYouJohnDoe": "Dank u, John Doe",
    "total": "Totaal",
    "urlExamples": {
      "simple": "voorbeeld.nl",
      "https": "https://voorbeeld.nl",
      "withPath": "voorbeeld.nl/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Bedankt dat u de tijd hebt genomen om deze quiz te voltooien."
  },
  "overallScore": {
    "defaultTitle": "Algemene score"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Individual keuze",
      "multipleChoice": "Meerkeuze",
      "yesNo": "Ja / Nee",
      "shortAnswer": "Short Response",
      "longAnswer": "Long Response",
      "number": "number",
      "singleDropdown": "Dropdown Individual",
      "multiDropdown": "Multi- Dropdown"
    },
    "personal": {
      "fullName": "Full Name",
      "firstName": "Voornaam",
      "lastName": "last Name",
      "dateOfBirth": "Date",
      "phone": "Telefoon",
      "email": "Gmail",
      "fullNamePlaceholder": "Voer uw volledige naam in",
      "firstNamePlaceholder": "Voer uw voornaam in",
      "lastNamePlaceholder": "Voer uw achternaam in",
      "dateOfBirthPlaceholder": "DD/MM/JJJJ",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Knop"
    },
    "integration": {
      "sellProducts": "Producten verkopen",
      "collectPayment": "Uitbetaling innen"
    },
    "address": {
      "address": "Adres",
      "streetAddress": "Straat Address",
      "city": "Stad",
      "state": "Staat",
      "country": "Land",
      "postalCode": "Code",
      "organization": "Group",
      "website": "Website",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Straatnaam",
      "streetAddressPlaceholder": "Voer uw volledige adres in",
      "cityPlaceholder": "Voer uw stad in",
      "statePlaceholder": "Voer uw provincie in",
      "countryPlaceholder": "Voer uw land in",
      "postalCodePlaceholder": "Postcode",
      "organizationPlaceholder": "Voer uw organisatie in"
    },
    "text": {
      "singleLine": "Line Individual",
      "multiLine": "Multi Line",
      "textBoxList": "List Square Square",
      "singleLinePlaceholder": "Voer uw tekst in",
      "multiLinePlaceholder": "Typ hier uw bericht"
    },
    "choiceElements": {
      "singleDropdown": "Dropdown Individual",
      "multiDropdown": "Multi- Dropdown",
      "checkbox": "Selectievakje",
      "radio": "Radio",
      "singleDropdownPlaceholder": "Selecteer een optie",
      "multiDropdownPlaceholder": "Kies één of meer opties",
      "pictureChoice": {
        "label": "Afbeelding Keuze",
        "multipleSelection": "Meerdere selecties",
        "selectionTypeLocked": "Het selectietype kan niet worden gewijzigd nadat dit aangepaste veld is opgeslagen.",
        "imageRequiredBeforeSave": "Elke optie in een Picture Choice-element moet een afbeelding bevatten.",
        "labelRequiredBeforeSave": "Elke optie in een Picture Choice-element moet een label hebben.",
        "duplicateOptionLabelsBeforeSave": "Elke optie in een Picture Choice-element moet een uniek label hebben.",
        "selectionLimitInvalidBeforeSave": "Voer een geldige selectielimiet in voor het element 'Picture Choice'.",
        "selectionLimit": "Selectielimiet",
        "unlimited": "Onbeperkt",
        "exact": "Exact",
        "range": "Bereik",
        "exactSelections": "Exacte selecties",
        "minimum": "Minimum",
        "maximum": "Maximaal",
        "options": "Opties",
        "optionSettings": "Optie-instellingen",
        "showOptionLabel": "Toon optielabel",
        "addOption": "Optie toevoegen",
        "otherOption": "Andere optie",
        "imageFit": "Afbeelding inpassen",
        "cover": "Omslag",
        "contain": "Bevat",
        "fill": "Vullen",
        "spreadToColumns": "Over kolommen verdelen",
        "columns": "Kolommen",
        "numberOfColumns": "Aantal kolommen",
        "desktopColumnsLimit": "Maximaal {count} kolommen op desktop.",
        "mobileColumnsLimit": "Maximaal {count} kolommen op mobiel.",
        "otherOptionLabel": "Ander optielabel",
        "optionLabel": "Optielabel",
        "image": "Afbeelding",
        "media": "Media",
        "otherImageUploadUnavailable": "Er kan geen afbeelding worden geüpload voor de optie Andere.",
        "removeImage": "Afbeelding verwijderen",
        "deleteOption": "Optie verwijderen",
        "altText": "Alternatieve tekst"
      }
    },
    "customized": {
      "text": "Tekst",
      "html": "HTML",
      "htmlPlaceholder": "De Custom HTML komt here te staan",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Uitdaging",
      "botProtection": "Botbescherming",
      "verificationMode": "Verificatiemodus",
      "interactive": "Interactief",
      "invisible": "Onzichtbaar",
      "invisibleModeDescription": "Deze verificatie wordt automatisch op de achtergrond uitgevoerd en is niet zichtbaar voor gebruikers",
      "fieldHiddenWarning": "Dit veld is verborgen en zal niet zichtbaar zijn op het formulier.",
      "verifyHuman": "Verifieer dat u een mens bent",
      "privacy": "Privacy",
      "help": "Help",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Bron",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "Ik ga akkoord met de voorwaarden Issued Via het bedrijf. Via mijn Phone Number te verstrekken, ga ik akkoord met Inherit Tekst berichten From the business.",
      "score": "Score",
      "scorePlaceholder": "Bijvoorbeeld: uw score is 100%"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Voer een URL in",
      "image": "Afbeelding",
      "fileUpload": "Upload File",
      "monetary": "Monetair",
      "number": "number",
      "datePicker": "Datum en tijd",
      "datePickerLegacy": "Date Picker",
      "datePickerGeneratedName": "Datum",
      "timePickerGeneratedName": "Tijd",
      "dateTimePickerGeneratedName": "Datum en tijd",
      "signature": "Handtekening",
      "monetaryPlaceholder": "Voer aantal in",
      "signaturePlaceholder": "Onderteken hier",
      "numberPlaceholder": "Voer een getal in",
      "datePickerPlaceholder": "DD/MM/JJJJ",
      "imageUploadPlaceholder": "Nog geen afbeelding toegevoegd",
      "imageUploadSubText": "Uploaden naar mediaopslag of slepen en neerzetten",
      "imageUploadButtonText": "Afbeelding uploaden",
      "fileText": "Bestand",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Klik om te uploaden"
    },
    "customstyle": "Stijl",
    "standard": "Standaard",
    "bubble": "Bubble"
  },
  "survey": {
    "addSlideText": "Elementen toevoegen",
    "defaultScreenTitle": "Componenten slepen en neerzetten",
    "defaultScreenDescription": "Verplaats uw vraag naar de {pageIndex}-pagina met behulp van de elementen aan de linkerkant.",
    "typeOfBuilder": "Enquête",
    "survyeStyle": "Enquetestijl",
    "surveyName": "Enquêtenaam",
    "surveyElement": "Enquête-element",
    "addSurveyElement": "Enquête-element toevoegen",
    "cloneSlide": "Slide klonen",
    "unsavedAlertMessage": "De enquête bevat niet-opgeslagen werk. Weet je zeker dat je al het niet-opgeslagen werk wilt wissen?",
    "thirdPartyScriptAlertMessage": "In het HTML-blok kunnen scripts van derden krachtige functionaliteit bieden, maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en paginagedrag. Daarom raden we je aan de inhoud van dit script te bekijken voordat je het opslaat in de enquête.",
    "integrateHeader": "Enquête integreren",
    "integrateSubHeader": "Gebruik de volgende opties om je aangepaste enquête in je website te integreren",
    "integrateCopyLinkMessage": "Kopieer onderstaande link om deze te delen.",
    "onSurveySubmission": "Bij het indienen van een enquête",
    "saveExitConfirmation": "Sla voortgang op voor enquêtes",
    "surveySettings": "Instellingen voor enquêtes",
    "oneQuestionAtTime": "Eén vraag tegelijk",
    "backButton": "Terugknop",
    "backButtonTooltipMessage": "Met de terugknop kunnen gebruikers naar de vorige dia gaan",
    "disableAutoNavigation": "Automatische navigatie uitschakelen",
    "disableAutoNavigationTooltipMessage": "Navigeert automatisch naar de Next Slide After a Operator reageert.",
    "autoNavigation": "Auto navigatie",
    "autoNavigationTooltipMessage": "Navigeert automatisch naar de Next Slide After a Operator reageert.",
    "progressBar": "Voortgangsbalk",
    "progressBarTooltipMessage": "Door dit uit te schakelen, wordt de voortgangsbalk uit de enquête verwijderd",
    "disableAnimation": "Animatie uitschakelen",
    "disableAnimationTooltipMessage": "Door dit in te schakelen, wordt de animatie bij de slideovergang uitgeschakeld",
    "scrollToTop": "Scroll naar boven",
    "scrollToTopTooltipMessage": "Door deze optie in te schakelen, wordt de enquête op de volgende slide naar boven gescrold",
    "submitSurvey": "Enquête Indienen",
    "disqualifyImmediately": "Onmiddellijk diskwalificeren",
    "disqualifyAfterSubmit": "Diskwalificeren na indiening",
    "disqualifyAfterSubmitLowerCase": "Diskwalificeren na verzenden",
    "footerHTML": "HTML-voettekst",
    "footerHTMLMessage": "Je kunt aangepaste CSS (met behulp van style tag) en HTML in hetzelfde vak schrijven",
    "editFooter": "Voettekst bewerken",
    "disqualifySettings": "Instellingen uitschakelen",
    "disqualifyImmediatelyLabel": "Onmiddellijk",
    "disqualifyAfterSubmitLabel": "Na het indienen",
    "slideConflictAlertMessage": "Deze dia bevat meerdere vragen waarvoor een logica is ingesteld. Dit kan onbedoeld gedrag veroorzaken",
    "addSlide": "Slide toevoegen",
    "settings": "Instellingen",
    "delete": "Verwijderen",
    "slideDeleteAlertMessage": "Weet je zeker dat je deze dia wilt verwijderen?",
    "slideDeleteBetweenAlertMessage": "Hiermee worden de andere slides opnieuw gerangschikt. Weet je zeker dat je deze slide wilt verwijderen?",
    "slideLabel": "Dia {n}",
    "slideName": "Naam slide",
    "slidePosition": "Positie slide",
    "jumpTo": "Ga naar",
    "jumpToSubText": "Ga naar een specifieke dia",
    "enableTimezoneSurvey": "Door deze optie te activeren, worden de gegevens van de tijdzone van de persoon die de enquête indient geregistreerd.",
    "footer": {
      "footer": "Voettekst",
      "enableNewFooter": "Nieuwe voettekst inschakelen",
      "stickToSurvey": " Blijf bij de enquête",
      "backgroundFill": "Achtergrondvulling",
      "footerHeight": "Hoogte voettekst",
      "enableProgressBar": "Voortgangsbalk inschakelen",
      "buttons": "Knop",
      "button": "Knop",
      "buttonType": "Type knop",
      "buttonTypeTooltip": "Kies hoe de navigatieknoppen in de voettekst van uw enquête worden weergegeven",
      "fillNext": "Invullen (volgende)",
      "fillPrevious": "Invullen (vorige)",
      "fillSubmit": "Invullen (indienen)",
      "textColor": "Knoptekst",
      "position": "Positie",
      "positionTooltip": "Kies hoe de navigatieknoppen in de voettekst van uw enquête worden weergegeven",
      "previousText": "Vorige (tekst)",
      "nextText": "Volgende (tekst)",
      "submitText": "Indienen (tekst)",
      "fillComplete": "Invullen voltooid",
      "fillInactive": "Invullen inactief",
      "footerType": "Voetteksttype",
      "stickToCard": "Op kaart plakken",
      "stickToPage": "Op pagina plakken",
      "stepTextColor": "Body kleur Step",
      "progressBarFill": "Progress bar Fill",
      "progressBarInactive": "Voortgangsbalk Inactief",
      "arrowFill": "Fill Arrow",
      "submitColorMobile": "Verzenden (Color)",
      "arrowFillColor": "Arrow Fill Color",
      "buttonTypes": {
        "textAndArrow": "Tekst & pijl",
        "onlyText": "Alleen tekst",
        "onlyArrow": "Alleen pijl"
      },
      "positions": {
        "leftAndRight": "Links en Rechts"
      },
      "placeholders": {
        "prev": "Vorige",
        "next": "Volgende",
        "submit": "Verzenden"
      }
    },
    "surveyNotfication": "Enquêtemelding",
    "style": {
      "surveyPadding": "Enquête-opvulling"
    },
    "integratePopup": {
      "shareOrEmbed": "Insluiten of delen van enquête",
      "share": {
        "openFormLink": "Linknaar Survey Open"
      },
      "email": {
        "emailSubheader": "Create een Embed e - Email en Embed uw Survey aan ."
      }
    },
    "autoResponderSubheader": "Verzend een automatische e-mail naar de persoon die de enquête indient (de e-mail bevat een kopie van de informatie die in de enquête werd ingevuld)",
    "sendSubmissionsAsPdf": "Enquête-inzending als pdf verzenden",
    "switchToOneQuestionAtTimeOn": "Het inschakelen van 'Eén Question op a Date' verstoort je Current voorwaardelijke Logic",
    "switchToOneQuestionAtTimeOff": "'One Question at a Date ' Disable invloed op je voorwaardelijke Logic Config",
    "switchToOneQuestionAtTimeOnWarning": "Sommige voorwaarden werken niet meer zoals verwacht When vragen zijn Showed op een Date.",
    "switchToOneQuestionAtTimeOffWarning": " Sommige voorwaarden voor Persoon- Question Flow werken niet meer zoals bedoeld.",
    "createContactOnPartialSubmissionSubText": "Er wordt een contactpersoon aangemaakt wanneer een gebruiker op \"Volgende\" klikt op een dia — zelfs als de enquête niet wordt voltooid.",
    "dragDrop": {
      "imageLabel": "Afbeelding {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Enquête {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Privacybeleid</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Servicevoorwaarden</a></p>",
      "smsConsent": "Ik geef toestemming om sms-meldingen, waarschuwingen en af en toe marketingcommunicatie van het bedrijf te ontvangen. De frequentie van het bericht varieert. Er kunnen kosten voor berichten en data in rekening worden gebracht. Stuur HELP naar (XXX) XXX-XXXX voor assistentie. U kunt zich op elk gewenst moment afmelden door te klikken op STOP."
    }
  },
  "form": {
    "typeOfBuilder": "Formulier",
    "formStyle": "Stijl formulier",
    "formElement": "Formulierelement",
    "addFormElement": "Formulierelement toevoegen",
    "addConditionalLogic": "Voorwaardelijke logica toevoegen",
    "openConditionalLogic": "Voorwaardelijke logica openen",
    "inlineForm": "Inline-formulier",
    "formName": "Naam formulier",
    "fullScreenMode": "Modus volledig scherm",
    "fullScreenModetooltip": "Door dit in te schakelen, breidt het formulier zich uit over de gehele breedte van de container, tot aan de rand van het inbeddingsgebied terwijl de breedte van het formulier blijft behouden.",
    "enableTimezoneForm": "Door deze optie te activeren, worden de gegevens van de tijdzone van de persoon die het formulier indient geregistreerd.",
    "formSettings": "Formulierinstellingen",
    "scheduleVisibility": {
      "title": "Plan de zichtbaarheid van {product}",
      "subtitle": "Stel in wanneer deze {product} moet beginnen en stoppen met het accepteren van reacties. Buiten dit tijdsvenster zien bezoekers de berichten die u hieronder configureert.",
      "formOpens": "{Product} opent",
      "formCloses": "{Product} sluit",
      "rightAway": "Direct",
      "never": "Nooit",
      "pickADate": "Kies een datum",
      "opensPlaceholder": "Opent zodra u publiceert",
      "closesPlaceholder": "Blijft open totdat u het sluit",
      "date": "Datum",
      "time": "Tijd",
      "timezone": "Tijdzone",
      "timezoneHelp": "Geldt voor zowel de openings- als sluitingstijden.",
      "timezonePlaceholder": "Selecteer een tijdzone",
      "timeline": {
        "notOpenYet": "Nog niet geopend",
        "acceptingResponses": "Reacties accepteren",
        "closed": "Gesloten",
        "current": "Huidige",
        "opens": "Opent",
        "closes": "Sluit"
      },
      "whatVisitorsSee": "Wat bezoekers zien",
      "whatVisitorsSeeHelp": "Deze pagina's worden alleen buiten het geopende venster weergegeven. Kies een staat om deze in te stellen.",
      "states": {
        "beforeTitle": "Voordat de {product} opent",
        "afterTitle": "Nadat de {product} sluit",
        "showsPage": "Toont een aangepaste pagina",
        "redirectsTo": "Wordt doorverwezen naar {url}"
      },
      "showPage": "Toon een pagina",
      "showPageHelp": "Ontwerp wat bezoekers zien.",
      "openLink": "Een link openen",
      "openLinkHelp": "Stuur ze naar een andere URL.",
      "redirectUrl": "Omleidings-URL",
      "redirectUrlPlaceholder": "https://example.com",
      "redirectUrlHelp": "Bezoekers in deze status worden hierheen gestuurd in plaats van dat ze een pagina zien. Gebruik een volledige URL zoals https://example.com/path.",
      "redirectUrlInvalid": "Voer een geldige URL in die begint met http:// of https://, zoals https://example.com/path.",
      "defaultBeforeMessage": "Deze {product} is nog niet geopend",
      "defaultAfterMessage": "Deze {product} is nu gesloten",
      "defaultBeforeBody": "Deze {product} accepteert nog geen reacties. Kom later terug zodra deze geopend is om uw reactie in te dienen.",
      "defaultAfterBody": "Bedankt voor uw interesse! Deze {product} accepteert geen reacties meer. Neem alstublieft contact op met de eigenaar van de {product} als u nog contact nodig heeft.",
      "closeAfterOpenError": "De sluitingstijd moet na de openingstijd liggen.",
      "preview": {
        "label": "Voorbeeldweergave",
        "labelHint": "— hoe bezoekers het zien",
        "redirectTo": "U wordt doorgestuurd naar:",
        "poweredBy": "Mogelijk gemaakt door uw agentschap"
      },
      "appearance": {
        "title": "Weergave",
        "cardBackground": "Achtergrond kaart",
        "pageBackground": "Achtergrond pagina",
        "cornerRadius": "Radius hoek",
        "cardWidth": "Kaartbreedte",
        "cardHeight": "Kaarthoogte",
        "shadow": "Schaduw",
        "autoPlaceholder": "Automatisch",
        "marginPadding": "Marge en padding",
        "auto": "automatisch",
        "miscellaneous": "Diversen",
        "agencyBranding": "Branding van het agentschap",
        "agencyBrandingHelp": "Toon uw logo van het agentschap en de naam op de pagina's in gesloten status.",
        "shadowOptions": {
          "none": "Geen",
          "soft": "Zacht",
          "elevated": "Verbeterd"
        },
        "colors": {
          "default": "Standaard",
          "lightGray": "Lichtgrijs",
          "brandTint": "Merktint",
          "blush": "Blush",
          "dark": "Donker",
          "white": "Wit",
          "coolGray": "Koelgrijs"
        }
      }
    },
    "saveExitConfirmation": "Sla voortgang op voor formulieren",
    "unsavedAlertMessage": "Het formulier heeft niet-opgeslagen werk. Weet je zeker dat je al het niet-opgeslagen werk wilt wissen?",
    "thirdPartyScriptAlertMessage": "In het HTML-blok kunnen scripts van derden krachtige functionaliteit bieden, maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en paginagedrag. Daarom raden we je aan om de inhoud van dit script te bekijken voordat je het opslaat in het formulier.",
    "onFormSubmission": "Bij het indienen van een formulier",
    "integrateForm": "Formulier integreren",
    "embedlayoutType": "Embed Layout Type",
    "embedlayoutTypeSubMessage": "Selecteer een lay-out om in te sluiten in een trechter of een externe website",
    "triggerType": "Triggertype",
    "showOnScrolling": "Weergeven tijdens het scrollen",
    "showAfter": "Weergeven na",
    "seconds": "seconden",
    "alwaysShow": "Altijd weergeven",
    "activationOptions": "Activatieopties",
    "activateOn": "Activeren op",
    "visit": "bezoeken",
    "alwaysActivated": "Altijd ingeschakeld",
    "deactivationOptions": "Deactivatieopties",
    "deactivateAfterShowing": "Uitschakelen na weergave",
    "times": "keer",
    "deactiveOnceLeadCollected": "Deactiveer zodra de lead is verzameld",
    "neverDeactivate": "Nooit uitschakelen",
    "copyEmbedCode": "Insluitcode kopiëren",
    "copyFormLink": "Link naar formulier kopiëren",
    "openFormLink": "Link naar formulier openen",
    "inline": "Inline",
    "inlineDescription": "Een inlineformulier wordt samen met de inhoud van de pagina als een native element getoond. Het is geen overlay en kan niet worden gesloten of geminimaliseerd.",
    "inlineHoverDescription": "Een inlineformulier wordt samen met de inhoud van de pagina als een native element getoond. Het is geen overlay en kan niet worden gesloten of geminimaliseerd.",
    "popup": "Pop-up",
    "popupDescription": "Een pop-up toont het formulier als een overlay in een lichtbak. Het kan niet geminimaliseerd maar wel gesloten worden.",
    "popupHoverDescription": "Een pop-up toont het formulier als een overlay in een lichtbak. Het kan niet geminimaliseerd maar wel gesloten worden.",
    "politeSlideIn": "Discrete slide-in",
    "politeSlideInDescription": "Onderaan het scherm verschijnt een discrete slide-in die verdwijnt wanneer het scherm wordt gesloten",
    "politeSlideInHoverDescription": "Verschijnt onderaan het scherm en verdwijnt wanneer het scherm wordt gesloten",
    "stickySidebar": "Vastgezette zijbalk",
    "stickySidebarDescription": "Aan de zijkant van het scherm verschijnt een vastgezette sidebar die kan worden geminimaliseerd tot een tabblad dat aan de zijkant van het venster blijft plakken.",
    "stickySidebarHoverDescription": "Verschijnt aan de zijkant van het scherm en kan worden geminimaliseerd tot een tabblad dat aan de zijkant van het venster blijft plakken",
    "allowMinimize": "Minimaliseren toestaan",
    "modalHeight": "Hoogte van modaal",
    "modalHeightPlaceholder": "Voer de hoogte van de modal in",
    "conditonalLogic": {
      "conditions": "Voorwaarden",
      "noExistingCondition": "Nog geen bestaande voorwaarden",
      "freeRoamMessage": "Je hebt de volledige vrijheid zonder regels - althans voorlopig",
      "addNewCondition": "Nieuwe conditie toevoegen",
      "redirectToUrl": "Doorverwijzen naar url",
      "displayCustomMessage": "Aangepast bericht weergeven",
      "disqualifyLead": "Lead diskwalificeren",
      "showHideFields": "Velden tonen/verbergen",
      "jumpTo": "Ga naar",
      "redirectToUrlSubText": "Operator omleiding na indiening",
      "displayCustomMessageSubText": "Show berichten op basis On Operator",
      "disqualifyLeadSubText": "Items onder specifieke voorwaarden eruit Filter",
      "showHideFieldsSubText": "Field Visibility Modify",
      "openBelowUrl": "Open de onderstaande URL",
      "showCustomMessage": "Aangepast bericht weergeven",
      "alertConditionDelete": "Weet je zeker dat je deze voorwaarde wilt verwijderen?",
      "deleteCondition": "Voorwaarde verwijderen",
      "conditionExecutedMessage": "Voorwaarden worden van boven naar beneden uitgevoerd.",
      "allOperationOptions": {
        "isEqualTo": "Is gelijk aan",
        "isNotEqualTo": "Is niet gelijk aan",
        "contains": "Bevat",
        "doesNotContain": "Bevat niet",
        "startsWith": "Begint met",
        "endsWith": "Eindigt met",
        "isEmpty": "Is leeg",
        "isFilled": "Is ingevuld",
        "before": "Voor",
        "after": "Na",
        "greaterThan": "Groter dan",
        "lessThan": "Lager dan",
        "between": "Tussen",
        "isChecked": "Is Aangevinkt",
        "isNotChecked": "Is niet gecontroleerd"
      },
      "logic": {
        "if": "Als",
        "then": "Dan",
        "and": "En",
        "or": "Of"
      },
      "phoneAlertMessage": "Om te zoeken op telefoonnummers met een landcode, moet je expliciet het '+'-symbool opnemen in je zoekopdracht.",
      "deleteAlertMessage": "Weet je zeker dat je dit veld wilt verwijderen? De voorwaarde die aan dit veld is gekoppeld, wordt dan ook verwijderd.",
      "deleteField": "Veld verwijderen",
      "jumpToDescription": "Ga naar een specifieke dia wanneer aan de voorwaarden is voldaan",
      "cycleError": "Kan niet opslaan. Loop gedetecteerd tussen {a} en {b}",
      "jumpToSlide": "Ga naar dia",
      "submitSurvey": "Enquête opslaan",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Selecteer de slide om van te springen",
      "selectedSlide": "Geselecteerde dia",
      "typeValueHere": "Typ hier een waarde in, alstublieft",
      "field": "Veld",
      "slide": "Slide",
      "selectFieldOrSlide": "Selecteren Sector Of Slide",
      "selectFieldState": "Selecteer veldstatus",
      "selectField": "Selecteer veld",
      "selectOption": "Optie selecteren",
      "jumpToTarget": "Ga naar",
      "jumpToQuestion": "Ga naar Vraag",
      "chooseQuestion": "Vraag kiezen",
      "includeStart": "Toevoegen beginnen",
      "includeEnd": "Einde toevoegen",
      "includeValue": "Toevoegen {value}",
      "hideField": "Veld verbergen",
      "hideFields": "Velden verbergen",
      "showField": "Toon Veld",
      "showFields": "Velden weergeven",
      "additionalRulesPrefix": "... en",
      "additionalRulesSuffix": "andere {ifLabel} regels ...",
      "shownTargetsWithMore": "{shown}, +{count} meer",
      "noConditionsAlt": "Nog geen voorwaarden",
      "outcomeLabels": {
        "show": "Tonen",
        "jumpTo": "Ga naar"
      }
    },
    "minimizedTitlePlaceholder": "Geminimaliseerde titel",
    "dragYourElementFromLeft": "Sleep je elementen naar hier vanaf links",
    "formNotification": "Formuliermelding",
    "sendSubmissionsAsPdf": "Formulierinzending als pdf verzenden",
    "style": {
      "formPadding": "Formulieropvulling"
    },
    "integratePopup": {
      "shareOrEmbed": "Insluiten of delen formulier",
      "share": {
        "openFormLink": "Form LinkOpen"
      },
      "email": {
        "emailSubheader": "Create een lege Email en Embed uw Form, of Select een Template en Embed it Immediately."
      }
    },
    "choosePosition": "Status Select",
    "testBuild": "Testbuild"
  },
  "quiz": {
    "quizElement": "Quiz-element",
    "quizNotification": "Quizmelding",
    "viewAndCustomise": "Bekijken en aanpassen",
    "categoryAndScore": "Categorie en score",
    "provideFeedback": "Feedback geven",
    "addQuizElement": "Quiz-element toevoegen",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Vragen Add",
    "dragAndDropQuestion": "Drag and drop a Question Element here.",
    "addNewPage": "Pagina toevoegen",
    "editTemplate": "Template Edit",
    "editResultPage": "Resultatenpagina bewerken",
    "clonePage": "Pagina klonen",
    "category": {
      "category": "Categorie",
      "useCategoryWhen": "Categories When gebruiken",
      "manageCategories": "Manage Categories",
      "howItWorks2": "Hoe werkt dit?",
      "addCategoryMessage": "Een new Category Add",
      "assignCategoryMessage": "Wijs een Category toe aan every optie",
      "editResultsMessage": "Category Page 'Show in",
      "toEvaluateTheResponder": "Om verschillende factoren op basis On antwoorden met Compare",
      "showMultipleCategoryScore": "Show meerdere Category score in Result Page",
      "displayVaryingContent": "Display wisselende Content On de resultaten Page afhankelijk On de scorecategorie van de Category",
      "addManage": "Add / Manage",
      "carouselAlt": "Dia met categorievoorbeeld"
    },
    "quizSettings": "Quiz-instellingen",
    "saveExitConfirmation": "Bewaar de voortgang voor quizzen",
    "onQuizSubmission": "Over het indienen van de quiz",
    "settings": "Instellingen",
    "deletePage": "Pagina verwijderen",
    "quizResult": {
      "resultTemplate": "Resultaatpagina sjabloon",
      "quizResultAlertMessage": "De gekozen resultatenpagina zal worden getoond zodra de quiz is voltooid",
      "overallScoreLabel": "Algemene score",
      "resultTemplateAlt": "Voorbeeld van een quizresultatensjabloon"
    },
    "deleteSlideMessage": "Weet u zeker dat u deze dia wilt verwijderen?",
    "autoResponderSubheader": "Verzend een automatische e-mail naar de persoon die de quiz heeft ingediend (de e-mail bevat een kopie van de informatie die bij de quiz werd ingevuld)",
    "sendSubmissionsAsPdf": "Quizinzending als pdf verzenden",
    "sendQuizResultsAsPdf": "Quizresultaat als pdf verzenden",
    "integrateHeader": "Quiz integreren",
    "integrateSubHeader": "Gebruik de volgende opties om je aangepaste quiz in je website te integreren",
    "integrateCopyLinkMessage": "Kopieer onderstaande link om deze te delen.",
    "pageLabel": "Pagina {n}",
    "pageName": "Paginanaam",
    "pagePosition": "Paginapositie",
    "createContactOnPartialSubmissionSubText": "Maakt een contact aan wanneer een gebruiker op \"Volgende\" klikt op een dia — zelfs als ze de quiz niet voltooien.",
    "integratePopup": {
      "shareOrEmbed": "Quiz Insluiten of Delen",
      "share": {
        "openFormLink": "Linknaar quiz Open"
      },
      "email": {
        "emailSubheader": "Create een blanco Email en Embed uw quiz, Of Select een Template en Embed it Immediately."
      }
    }
  },
  "textEditor": {
    "textAlign": "Tekstuitlijning",
    "list": "Lijst",
    "sourceCode": "Broncode",
    "resetStyle": "Stijl terugzetten",
    "resetDocumentStyle": "Documentstijl terugzetten"
  }
}
